import { useRef, useState, useEffect } from 'react';
import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { Calendar, X } from 'lucide-react';

const RangePickerWithInput = ({sateValChange,clearDates}) => {
  const [range, setRange] = useState({ from: undefined, to: undefined });
  const [showPicker, setShowPicker] = useState(false);
  const [hovered, setHovered] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if(clearDates === 'Yes') {
      let dlfDate = { from: undefined, to: undefined };
      setRange(dlfDate);
      //sateValChange('clearDates','No');
    }
  }, [clearDates]);

  const handleCloseDpk = () => {
    setShowPicker(false);
  }

  const handleMouseEnter = () => {
    console.log("Mouse entered the input");
    setHovered(true);
  };

  const handleMouseLeave = () => {
    console.log("Mouse left the input");
    setHovered(false);
  };

  const handleSelect = (selectedRange) => {
    setRange(selectedRange);
    if (selectedRange?.from && selectedRange?.to) {
      sateValChange('selecteddate',selectedRange)
      setShowPicker(false); // Close calendar after full selection
    }
  };

  const formatRange = () => {
    if (!range.from) return '';
    if (!range.to) return format(range.from, 'MMM d, yyyy');
    return `${format(range.from, 'MMM d, yyyy')} - ${format(range.to, 'MMM d, yyyy')}`;
  };

  return (
    <div className='daterangpiker_main' style={{ position: 'relative' }}>
      <Calendar className={(hovered)?'h-4 w-4 calender-iconcls-active':'h-4 w-4 calender-iconcls'} />
      <input
        ref={ref}
        readOnly
        value={formatRange()}
        onClick={() => setShowPicker((prev) => !prev)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        placeholder="Select date range"
        className='daterangpiker_inputfld'
        style={{ padding: '6px 6px 6px 32px', width: '240px', fontSize: '14px' }}
      />
      {showPicker && (<button type="button" onClick={handleCloseDpk} className="btn btn-label-secondary datepkr-close-btn"><X /></button>)}
      {showPicker && (
        <div className='daterangpiker_popup' style={{ position: 'absolute', top: 38, zIndex: 10 }}>
          <DayPicker
            mode="range"
            selected={range}
            onSelect={handleSelect}
            numberOfMonths={2}
            showOutsideDays
            weekStartsOn={0}
          />
        </div>
      )}
    </div>
  );
};

export default RangePickerWithInput;
